// How long a market order has been waiting on staff (owner, 2026-10-30:
// «Show each waiting order's age so nothing sits for long»). A paid order waits
// from payment; one awaiting a shipping price waits from creation.
// Amber after 24 hours, red after 48.

export const WAITING_STATUSES = ['awaiting_shipping_quote', 'paid', 'disputed', 'refund_pending'];

export function waitingSince(o) {
  if (!WAITING_STATUSES.includes(o?.status)) return null;
  return o.status === 'awaiting_shipping_quote' ? o.created_at : (o.paid_at || o.created_at);
}

export function waitAge(since, now = Date.now()) {
  if (!since) return null;
  const hours = Math.max(0, Math.floor((now - new Date(since).getTime()) / 3600000));
  return { hours, tone: hours >= 48 ? 'red' : hours >= 24 ? 'amber' : 'ok' };
}

export function ageLabel(hours, isAr) {
  if (hours < 1) return isAr ? 'أقل من ساعة' : 'under 1 h';
  if (hours < 24) return isAr ? `${hours} ساعة` : `${hours} h`;
  const d = Math.floor(hours / 24), h = hours % 24;
  return isAr ? `${d} يوم${h ? ` و${h} ساعة` : ''}` : `${d} d${h ? ` ${h} h` : ''}`;
}

// The oldest waiting order first, so nothing sits behind newer ones.
export function byWaitingAge(rows) {
  return [...rows].sort((a, b) => new Date(waitingSince(a) || a.created_at) - new Date(waitingSince(b) || b.created_at));
}
